/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon64Regular = forwardRef('ArrowUiCornerOutUpRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M17.5 10a7.5 7.5 0 0 0-7.5 7.5v29a7.5 7.5 0 0 0 7.5 7.5h29a7.5 7.5 0 0 0 7.5-7.5v-7a1.5 1.5 0 0 1 3 0v7C57 52.299 52.299 57 46.5 57h-29C11.701 57 7 52.299 7 46.5v-29C7 11.701 11.701 7 17.5 7h7a1.5 1.5 0 0 1 0 3h-7Z" }),
        React.createElement("path", { d: "m54 12.121-20.94 20.94a1.5 1.5 0 0 1-2.12-2.122L51.878 10H36.5a1.5 1.5 0 0 1 0-3h17a3.5 3.5 0 0 1 3.5 3.5v17a1.5 1.5 0 0 1-3 0V12.121Z" })));
});
